import type { ProductImageEntry } from "./types";
const tabs = [
  {
    id: "visits",
    sv: "Besök",
    en: "Visits",
    showsSv:
      "Besökslistan visar tilldelade och otilldelade besök för den valda timmen.",
    showsEn:
      "The visit list shows assigned and unassigned visits for the selected hour.",
  },
  {
    id: "shifts",
    sv: "Pass",
    en: "Shifts",
    showsSv: "Passlistan visar bemanning som överlappar den valda timmen.",
    showsEn: "The shift list shows staffing that overlaps the selected hour.",
  },
  {
    id: "windows",
    sv: "Tidsfönster",
    en: "Time windows",
    showsSv: "Tabellen visar krav och önskade tidsfönster för timmens besök.",
    showsEn:
      "The table shows required and preferred time windows for visits in the hour.",
  },
  {
    id: "solver",
    sv: "Lösarkonfig",
    en: "Solver configuration",
    showsSv: "Tabellen visar tillämpade lösarvikter och deras referensvärden.",
    showsEn:
      "The table shows applied solver weights and their reference values.",
  },
  {
    id: "capacity",
    sv: "Kapacitet",
    en: "Capacity",
    showsSv:
      "Kapacitetskort visar efterfrågan, utbud och otilldelad tid för den valda timmen.",
    showsEn:
      "Capacity cards show demand, supply and unassigned time for the selected hour.",
  },
];
export const HOURLY_BOTTLENECK_CATALOGUE: readonly ProductImageEntry[] =
  tabs.map((tab) => ({
    id: `analytics.hourly-inspector.${tab.id}`,
    module: `Flaskhalsar · ${tab.sv}`,
    area: "solution",
    opens: `Analys → Flaskhalsar → timme → ${tab.sv}`,
    setup: [
      "Välj en timme med sparade besök, överlappande pass och otilldelad efterfrågan",
      `Öppna fliken ${tab.sv}`,
    ],
    scenario: "S2",
    visual: { variant: 0 },
    use: ["pages/Plattform.tsx"],
    text: {
      sv: {
        alt: `Timinspektörens ${tab.sv.toLowerCase()} för en sparad lösning`,
        shows: tab.showsSv,
        proves:
          "Uppgifterna läses från samma valda timme i det färdiga DEV-resultatet för den accepterade Carefox-perioden.",
      },
      en: {
        alt: `The hourly inspector's ${tab.en.toLowerCase()} for a saved solution`,
        shows: tab.showsEn,
        proves:
          "The data comes from the same selected hour in the completed DEV result for the accepted Carefox period.",
      },
    },
  }));
